import { Company, Registration } from '@legacy-types';

import { ContextSelector } from '@shared/layout/components/ContextSelector';

type CompanyHeaderProps = {
  company: null | Company;
  companies: Company[];
  registration: Registration;
  registrations: Registration[];
  onCompanyChange: (company: Company) => void;
  onRegistrationChange: (registration: Registration) => void;
};

export function CompanyHeader({
  company,
  companies,
  registration,
  registrations,
  onCompanyChange,
  onRegistrationChange,
}: CompanyHeaderProps) {
  return (
    <div className="flex flex-wrap items-center gap-3 lg:gap-6">
      {company && companies.length > 0 && (
        <ContextSelector
          selected={company}
          options={companies}
          icon="company"
          label={(company) => company.name}
          onSelect={onCompanyChange}
        />
      )}
      {registration && registrations.length > 0 && (
        <ContextSelector
          selected={registration}
          options={registrations}
          icon="company"
          label={(registration) => registration.event.name}
          onSelect={onRegistrationChange}
        />
      )}
    </div>
  );
}
